(function () {

    'use strict';

    var ngModule = angular.module('breakmarkApp');

	ngModule.directive('selectStore', [ 'SplashModalService', '$Stores', function (SplashModalService, $Stores) {
		return {
			scope: {
				entity: '='
			},
			templateUrl: 'directives/selectStore/element.html',
			controller: function($scope) {
				$scope.mode = 'button';
				$scope.storeList = $Stores.all();

				$scope.data = {
					current: $scope.entity.store || {},
					was: $scope.entity.store || {},
					selection: null
				};

				$scope.makeEditable = function() {
					$scope.mode = 'edit';
				};

				$scope.cancel = function() {
					$scope.mode = 'button';
				};

				$scope.save = function() {
					$scope.data.current = $scope.data.selection;
					$scope.entity.store = $scope.data.selection;
					$scope.mode = 'button';
				};
			}
		};
	}]);

})();
